// src/components/Sidebar.jsx
import "./Sidebar.scss";

import { Form, Nav, Offcanvas } from "react-bootstrap";
import React, { useEffect, useMemo, useState } from "react";
import { selectedCompany, setCompanies } from "../redux/actions/companyAction";
import { useDispatch, useSelector } from "react-redux";

import Dropdown from "react-bootstrap/Dropdown";
import NotificationAPI from "../pages/my-account/notifications/NotificationAPI";
import SidebarItem from "./SidebarItem";
import SidebarSubItem from "./SidebarSubItem";
import UserService from "../auth/UserService";
import { displayName } from "../commons/util/HallAppUtil";
import packageJson from "../../package.json";

const service = new UserService();
const LOCAL_STORAGE_KEY = "hallapp-menu-config";
const notificationAPI = new NotificationAPI();

export const menuItems = [
  { label: "Início", path: "inicio", isRoute: true, validateAdmin: false, showMenuReception: false, section: "Início" },
  { label: "Minha Conta", path: "minha-conta", isRoute: true, validateAdmin: false, section: "Início" },
  { label: "Notificações", path: "notificacoes", isRoute: true, validateAdmin: false, section: "Início" },
  { label: "Personalizar Menu", path: "menu-personalizar", isRoute: true, validateAdmin: true, section: "Início" },

  { label: "Comandas", path: "comandas", isRoute: true, validateAdmin: false, showMenuReception: false, section: "Atendimento" },
  { label: "Atendimentos", path: "comandas-recepcao", isRoute: true, validateAdmin: false, showMenuReception: true, section: "Atendimento" },
  { label: "Caixa e Despesas", path: "external-transactions", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Atendimento" },
  { label: "Caixa", path: "fechamento-caixa", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Atendimento" },
  { label: "Feedbaks de Clientes", isNew: false, path: "feedback", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Atendimento" },
  { label: "Promoções", path: "promotions", isNew: false, isRoute: true, validateAdmin: false, showMenuReception: false, section: "Atendimento" },
  { label: "Pacotes", path: "pacotes", isNew: true, isRoute: true, validateAdmin: false, showMenuReception: false, section: "Atendimento" },

  {
    label: "Avaliações & Anamnese",
    path: "relatorios",
    isRoute: false,
    section: "Atendimento",
    validateAdmin: true,
    showMenuReception: false,
    children: [
      { label: "Formulários", path: "forms", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
      { label: "Protocolos", path: "protocolos", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
      { label: "Anamnese", path: "anamnese", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
      { label: "Análise Tricoscópica", path: "analises", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
    ],
  },

  {
    label: "Programa de Pontos",
    path: "relatorios",
    isRoute: false,
    section: "Atendimento",
    validateAdmin: true,
    showMenuReception: false,
    children: [
      { label: "Simular Pontos", path: "hallpoints-simulador", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
      { label: "Como Ganhar Pontos", path: "hallpoints-configuracao", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
      { label: "Resgatar Pontos", path: "hallpoints-recompensas", isRoute: true, validateAdmin: false, main: "Atendimento", showMenuReception: false },
    ],
  },

  {
    label: "Club de Assinaturas",
    path: "clube",
    isRoute: false,
    isNew: false,
    section: "Atendimento",
    validateAdmin: true,
    showMenuReception: false,
    children: [
      { label: "Configuração", path: "clube/pagamentos", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
      { label: "Clubs", path: "clubes", isRoute: true, validateAdmin: true, main: "Atendimento", showMenuReception: false },
    ],
  },

  {
    label: "Relatórios",
    path: "relatorios",
    isRoute: false,
    section: "Relatórios",
    validateAdmin: true,
    showMenuReception: false,
    children: [
      { label: "Relatório de Atendimentos", path: "relatorio", isRoute: true, validateAdmin: true, main: "relatorios", showMenuReception: false },
      { label: "Relatório Geral", path: "relatorio-completo", isRoute: true, validateAdmin: true, main: "relatorios", showMenuReception: false },
    ],
  },

  { label: "Minha Agenda", path: "agenda", isRoute: true, validateAdmin: false, showMenuReception: false, section: "Agenda" },
  { label: "Agendamentos Fixos", path: "agendamento-recorrente", isRoute: true, validateAdmin: false, showMenuReception: false, section: "Agenda" },

  {
    label: "Configurações da Agenda",
    path: "agenda",
    isRoute: false,
    section: "Agenda",
    children: [
      { label: "Site de Agendamento", path: "configurar-agenda", isRoute: true, validateAdmin: true, main: "Agenda", showMenuReception: false },
      { label: "Horários de Funcionamento", path: "agenda-semanal", isRoute: true, validateAdmin: false, main: "Agenda", showMenuReception: false },
      { label: "Feriados e Folgas", path: "folgas", isRoute: true, validateAdmin: false, main: "Agenda", showMenuReception: false },
    ],
  },

  { label: "Meu Estabelecimento", path: "meus-estabelecimentos", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Configurações" },
  { label: "Equipe", path: "funcionarios", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Configurações" },
  { label: "Máquinas de Cartão", path: "maquininha", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Configurações" },
  { label: "Serviços do Salão", path: "servicos", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Configurações" },
  // { label: "Clientes", path: "clientes", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Configurações" },
  { label: "Estoque de Produtos", path: "estoque", isRoute: true, validateAdmin: false, showMenuReception: false, section: "Configurações" },

  { label: "WhatsApp Automático", path: "whats-config", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Automação" },
  { label: "Assistente Virtual (Hallie)", path: "hallie", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Automação" },
  { label: "Gerador de Reels", path: "instagram/gerador-reels", isRoute: true, validateAdmin: true, showMenuReception: false, section: "Automação" },
];

const Sidebar = ({ show, handleClose }) => {
  const [userLogged, setUserLogged] = useState(null);
  const [searchCompany, setSearchCompany] = useState("");
  const [menuConfig, setMenuConfig] = useState({ enabledMap: {}, defaultPath: "inicio" });

  const dispatch = useDispatch();
  const companyManagement = useSelector((state) => state.company.companyManagement);
  const companiesUserLogged = useSelector((state) => state.company.companies);

  useEffect(() => {
    if (show) {
      const user = service.getUserData();
      setUserLogged(user);
      const companies = JSON.parse(localStorage.getItem("companies")) || [];
      dispatch(setCompanies(companies));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    const user = service.getUserData();
    setUserLogged(user);
    getCompanies();
    fetchCountNotification();

    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setMenuConfig({
          enabledMap: parsed.enabledMap || {},
          defaultPath: parsed.defaultPath || "inicio",
        });
      } catch (_) {
        console.warn("Erro ao ler configuração de menu do localStorage (sidebar)");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCountNotification = async () => {
    try {
      const resp = await notificationAPI.countNotifications();
      localStorage.setItem("count_notification", resp?.data || 0);
    } catch (_) {
      localStorage.setItem("count_notification", 0);
    }
  };

  const getCompanies = () => {
    const companies = JSON.parse(localStorage.getItem("companies")) || [];
    dispatch(setCompanies(companies));
  };

  const setCompany = (company) => dispatch(selectedCompany(company));

  const isAdmin = useMemo(() => userLogged?.rules?.includes("COMPANY"), [userLogged]);
  const isReception = useMemo(() => userLogged?.rules?.includes("RECEPTION"), [userLogged]);

  const selectedCompanyLabel = useMemo(() => {
    if (!companiesUserLogged || companiesUserLogged.length === 0) return "Nenhuma empresa associada";
    const cm = companyManagement || JSON.parse(localStorage.getItem("company-management")) || {};
    const nm = cm?.name || "";
    const unit = cm?.unit || "";
    return unit ? `${nm} - ${unit}` : nm || "Selecionar empresa";
  }, [companiesUserLogged, companyManagement, show]);

  const filteredCompanies = useMemo(() => {
    const q = (searchCompany || "").toLowerCase().trim();
    if (!q) return companiesUserLogged || [];
    return (companiesUserLogged || []).filter((c) => `${c?.name || ""} ${c?.unit || ""}`.toLowerCase().includes(q));
  }, [companiesUserLogged, searchCompany]);

  const groupedMenu = useMemo(() => {
    const enabledMap = menuConfig.enabledMap || {};

    const allowed = menuItems.filter((item) => {
      const itemAllowed =
        (item.validateAdmin && isAdmin) ||
        (item.showMenuReception && isReception) ||
        (!item.validateAdmin && !item.showMenuReception);

      if (!itemAllowed) return false;

      const hasConfig = Object.keys(enabledMap).length > 0;

      const isPersonalizarMenu = item.label === "Personalizar Menu";
      if (isPersonalizarMenu) return true;

      if (!hasConfig) return true;

      if (item.children?.length) {
        const parentEnabled = enabledMap[item.path] !== false;
        const childEnabled = item.children.some((child) => enabledMap[child.path] !== false);
        return parentEnabled || childEnabled;
      }

      return enabledMap[item.path] !== false;
    });

    return allowed.reduce((acc, item) => {
      const section = item.section || "Outros";
      if (!acc[section]) acc[section] = [];
      acc[section].push(item);
      return acc;
    }, {});
  }, [isAdmin, isReception, show, menuConfig]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      scroll
      backdrop={false}
      className="custom-sidebar"
      aria-label="Menu lateral de navegação"
    >
      <Offcanvas.Header closeButton className="border-bottom">
        <div className="d-flex align-items-center gap-2">
          <div className="sidebar-logo rounded-circle bg-primary text-white d-flex align-items-center justify-content-center">H</div>
          <div className="fw-semibold">HallApp</div>
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Nav className="flex-column">
          <div className="sidebar-greeting mb-3">
            <div className="d-flex align-items-center gap-2">
              <div className="avatar bg-secondary text-white rounded-circle d-inline-flex align-items-center justify-content-center">
                {displayName(userLogged?.name)?.[0] ?? "U"}
              </div>
              <div>
                <div className="small text-muted">Olá,</div>
                <div className="fw-semibold">{displayName(userLogged?.name)}</div>
                <div className="small text-muted">{userLogged?.email}</div>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <Dropdown>
              <Dropdown.Toggle className="dropdown-company w-100" disabled={!companiesUserLogged?.length} variant="success" id="dropdown-company">
                {selectedCompanyLabel}
              </Dropdown.Toggle>

              <Dropdown.Menu className="w-100 p-2">
                {companiesUserLogged?.length > 6 && (
                  <Form.Control
                    size="sm"
                    type="text"
                    placeholder="Buscar empresa..."
                    className="mb-2"
                    value={searchCompany}
                    onChange={(e) => setSearchCompany(e.target.value)}
                  />
                )}

                {(filteredCompanies || []).map((company) => {
                  const key = `${company.id}-${company.unit || ""}`;
                  const isActive = companyManagement?.id === company.id && (companyManagement?.unit || "") === (company.unit || "");
                  return (
                    <Dropdown.Item key={key} active={!!isActive} onClick={() => setCompany(company)} eventKey={key}>
                      {company?.name} {company?.unit ? `- ${company.unit}` : ""}
                    </Dropdown.Item>
                  );
                })}

                {(!filteredCompanies || filteredCompanies.length === 0) && (
                  <div className="text-muted small px-2 py-1">Nenhuma empresa encontrada</div>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <hr />

          {Object.entries(groupedMenu).map(([sectionTitle, items]) => (
            <div key={sectionTitle}>
              <div className="sidebar-section-title">{sectionTitle}</div>

              {items.map((item) => (
                <SidebarSubItem
                  key={`${sectionTitle}-${item.label}-${item.path}`}
                  {...item}
                  handleClose={handleClose}
                  isUserAdmin={isAdmin}
                  unreadCount={localStorage.getItem("count_notification") || 0}
                />
              ))}

              <hr />
            </div>
          ))}

          <SidebarItem label="Sair" path="login" handleClose={handleClose} />
          <SidebarItem label="Suporte" path="suporte" handleClose={handleClose} />
          <SidebarItem label="Atualizar App" path="update-app" handleClose={handleClose} />
          <SidebarItem label="Instalar HallApp" path="instalar" handleClose={handleClose} />

          {isAdmin && <SidebarItem label="Assinaturas" path="assinatura" handleClose={handleClose} />}

          <div className="profile-section mt-3 pt-2 border-top">
            <div className="profile-info">
              <strong>{displayName(userLogged?.name)}</strong>
              <div className="small text-muted">{userLogged?.email}</div>
              <div className="small text-muted">Versão {packageJson.version}</div>
            </div>
          </div>
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Sidebar;
